export default function printReportRegisters(name, ...params) {
  const token = localStorage.getItem("token");

  if (name === "Clientes") {
    reportCustomers(token)
  }
  if (name === "PropriedadesPorCliente") {
    reportCustomerProperties(token)
  }
  if (name === "Colaborador") {
    reportEmployees(token)
  }
  if (name === "Fornecedores") {
    reportSupplier(token)
  }
  if (name === "Produtos") {
    reportProdutcs(token)
  }
  if (name === "MargemFornecedor") {
    reportSupplierProfit(token, ...params)
  }
}

function reportCustomers(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/customers/gerar/relatorio/geral/?auth=${token}`
  );
}
function reportCustomerProperties(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/customer_properties/generate/report/by-customer?auth=${token}`
  );
}
function reportEmployees(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/employees/report/all/employee/print/?auth=${token}`
  );
}
function reportSupplier(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/providers/print/report/all/?auth=${token}`
  );
}
function reportProdutcs(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/products/print/report/all/a4/?auth=${token}`
  );
}

function reportSupplierProfit(token, idFornecedor = "") {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/providers/print/report/all/profit?auth=${token}&idFornecedor=${idFornecedor}`
  );
}
